import { defineComponent as h, computed as l, openBlock as s, createElementBlock as i, createElementVNode as t, toDisplayString as d, createCommentVNode as v, normalizeStyle as n, createStaticVNode as f } from "vue";
const p = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "d7771086-0ade-4e4a-9a0f-dd635cf3bb87" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), _ = { mask: "url(#d7771086-0ade-4e4a-9a0f-dd635cf3bb87)" }, k = { key: 0 }, u = /* @__PURE__ */ f('<path fill="#ffda44" d="M0 0v57l32 29-32 28v57l32 29-32 28v57l32 28-32 28v57l32 29-32 28v57h512v-57l-32-28 32-29v-57l-32-28 32-28v-57l-32-28 32-29v-57l-32-28 32-29V0H0z"></path><path fill="#d80027" d="M0 57h512v57H0Zm0 114h512v57H0Zm0 114h512v56H0Zm0 113h512v57H0Z"></path><path fill="#ff9811" d="M96 128v160l96 96c53 0 96-43 96-96l-48-48 48-48v-64h-28v32h-27v-32h-27v32h-28v-32h-27v32h-28v-32z"></path><path fill="#0052b4" d="M192 192h96v96h-96z"></path><path fill="#eee" d="M192 288v96a96 96 0 0 1-96-96Z"></path>', 5), g = { fill: "none" }, x = ["r"], W = /* @__PURE__ */ h({
  __name: "es-ar",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const e = r, o = l(() => 512 + 2 * e.strokeWidth), a = l(() => -e.strokeWidth), c = l(() => 256 + e.strokeWidth / 2);
    return (w, y) => (s(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${a.value} ${a.value} ${o.value} ${o.value}`
    }, [
      m,
      t("g", _, [
        e.flagName ? (s(), i("title", k, d(e.flagName), 1)) : v("", !0),
        u
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: c.value,
          fill: "none",
          style: n({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, p));
  }
});
export {
  W as default
};
//# sourceMappingURL=es-ar-bc72dc21.js.map
